import Vue from 'vue';
import Component from 'vue-class-component';
import { Inject, Prop } from 'vue-property-decorator';

import { 
  RemoveTool,
  BringToFrontTool,
  BringForwardTool,
  SendToBackTool,
  SendBackwardTool
} from '../../designer-tools.values';
import { DesignerStateProvider } from '../../designer.provider';
import { DesignerElementTypes } from '../../designer.enum';

@Component({
  name: 'ed-designer-elements-tools',
  components: {
    EdCollaborativeTextToolbar: () => import(/* webpackChunkName: "ed-collaborative-text-toolbar" */ '@/components/common/ed-collaborative-text-editor/ed-collaborative-text-toolbar.vue'),
    EdDesignerElementsToolsItem: () => import(/* webpackChunkName: "ed-designer-elements-tools-item" */ '../ed-designer-elements-tools-item/ed-designer-elements-tools-item.component.vue'),
    EdDesignerElementsToolsItemBackground: () => import(/* webpackChunkName: "ed-designer-elements-tools-item-background" */ '../ed-designer-elements-tools-item-background/ed-designer-elements-tools-item-background.component.vue'),
  }
})
export default class EdDesignerElementsTools extends Vue {
  @Prop({ default: () => [] }) readonly toolsDisabled: string[];

  @Inject()
  readonly DesignerStateProvider: DesignerStateProvider;

  readonly RemoveTool = RemoveTool;
  readonly BringToFrontTool = BringToFrontTool;
  readonly BringForwardTool = BringForwardTool;
  readonly SendToBackTool = SendToBackTool;
  readonly SendBackwardTool = SendBackwardTool;

  get isTextElement(): boolean {
    return this.DesignerStateProvider.elementSelected?.type === DesignerElementTypes.Text;
  }

  get hasTextToolbar(): boolean {
    return this.isTextElement && !this.DesignerStateProvider.quillIsHidden;
  }

  get textToolbarId(): string {
    return this.DesignerStateProvider.quillTextToolbarId;
  }

  get textInstance(): any {
    return this.DesignerStateProvider.quillTextInstance;
  }

  get isTextOnPreRender(): boolean {
    return this.DesignerStateProvider.isTextOnPreRender;
  }

  get textToolbarClasses(): any {
    return {
      'text-toolbar--hidden': this.DesignerStateProvider.isTextOnPreRender,
    }
  }

  onQuillReady() {
    this.DesignerStateProvider.quillIsReady = true;
  }
}